import {
  Box,
  LinearProgress,
  Paper,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useEffect, useState } from "react";
import Admin from "../../../Pages/Admin";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import usePostData from "../../../utility/usePostData";

const AddFormulaireDeclaration = () => {
  const [title, setTitle] = useState("");
  const { error, submitData } = usePostData();
  const { data, isLoading, refreshSearch } =
    useFetchDataWithPagination("downloawddoc");
  const [groupeFormulaire, setgroupeFormulaire] = useState(null);
  const [groupeId, setGroupeId] = useState(null);
  const [showUploadFormulaire, setShowUploadFormulaire] = useState(0);
  const [titleFormulaire, setTitleFormulaire] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (data?.data) {
      setgroupeFormulaire(data?.data);
    }
    return () => {};
  }, [data]);

  const addDocument = (e) => {
    setShowUploadFormulaire(e.id);
    setGroupeId(e.id);
  };

  const handleCloseModal = () => {
    setShowUploadFormulaire(0);
    setGroupeId(null);
    setSelectedFile(null);
    setTitleFormulaire("");
  };

  const uploadFile = (e) => {
    e.preventDefault();
    if (!selectedFile || !titleFormulaire) {
      alert("Veuillez remplir tous les champs");
      return;
    }
    
    const form = new FormData();
    form.append("file", selectedFile);
    form.append("title", titleFormulaire);
    form.append("downloawd_doc_id", groupeId);
    submitData("file_declarations", form);
    
    handleCloseModal();
    refreshSearch();
  };

  const updateGroupe = (item) => {
    setGroupeId(item.id);
    setTitle(item.title);
  };

  const saveGroupe = (e) => {
    e.preventDefault();
    const x = { title: title };
    if (groupeId) {
      submitData("downloawddoc/" + groupeId, x, "PUT");
      setGroupeId(null);
    } else {
      submitData("downloawddoc", x, "POST");
    }

    setTitle("");
    setGroupeId(null);
    refreshSearch();
  };

  return (
    <Admin>
      <Box sx={{ width: "95%", margin: "auto", mt: 4 }}>
        <Paper
          elevation={2}
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: "#fff",
          }}
        >
          {isLoading && (
            <LinearProgress
              sx={{
                backgroundColor: "#e0e0e0",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#00a652",
                },
              }}
            />
          )}

          <Typography
            variant="h5"
            sx={{
              color: "#00a652",
              mb: 4,
              fontWeight: 500,
              borderBottom: "2px solid #00a652",
              paddingBottom: 1,
              display: "inline-block",
            }}
          >
            Ajouter un groupe de Formulaire
          </Typography>

          <form onSubmit={saveGroupe}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mb: 4,
                alignItems: "flex-start",
              }}
            >
              <TextField
                size="small"
                label="Titre du groupe"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                error={!!error}
                helperText={error?.message}
                sx={{
                  flexGrow: 1,
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#00a652",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00a652",
                    },
                  },
                }}
              />
              <Button
                type="submit"
                variant="contained"
                startIcon={groupeId ? <EditIcon /> : <AddIcon />}
                sx={{
                  backgroundColor: "#00a652",
                  "&:hover": { backgroundColor: "#008c46" },
                  transition: "background-color 0.3s",
                  textTransform: "none",
                  minWidth: "150px",
                }}
              >
                {groupeId ? "Modifier" : "Sauvegarder"}
              </Button>
            </Box>
          </form>

          {groupeFormulaire && (
            <Box sx={{ mt: 5 }}>
              <Typography
                variant="h6"
                sx={{
                  color: "#00a652",
                  mb: 3,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <AddIcon /> Liste des Formulaires
              </Typography>

              <TableContainer
                sx={{
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                  borderRadius: 1,
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#00a652" }}>
                      <TableCell sx={{ color: "white", fontWeight: 500 }}>
                        #
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 500 }}>
                        Titre
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 500 }}>
                        Contenu
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 500 }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupeFormulaire.map((item, index) => (
                      <TableRow
                        key={item.id}
                        hover
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(0,166,82,0.04) !important",
                          },
                        }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.title}</TableCell>
                        <TableCell>
                          <ul
                            style={{
                              listStyle: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            {item.documents &&
                              item.documents.map((doc) => (
                                <li
                                  key={doc.id}
                                  style={{
                                    marginBottom: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <FileUploadIcon
                                    sx={{ color: "#00a652", fontSize: 18 }}
                                  />
                                  <a
                                    href={doc.name}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      color: "#00a652",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {doc.title}
                                  </a>
                                </li>
                              ))}
                          </ul>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                              size="small"
                              startIcon={<AddIcon />}
                              onClick={() => addDocument(item)}
                              sx={{
                                color: "#00a652",
                                borderColor: "#00a652",
                                "&:hover": {
                                  backgroundColor: "rgba(0,166,82,0.04)",
                                },
                              }}
                              variant="outlined"
                            >
                              Document
                            </Button>
                            <IconButton
                              size="small"
                              onClick={() => updateGroupe(item)}
                              sx={{ color: "#00a652" }}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const r = window.confirm("Vous êtes sûr ?");
                                if (r) {
                                  submitData(
                                    "downloawddoc/" + item.id,
                                    null,
                                    "DELETE"
                                  );
                                  refreshSearch();
                                }
                              }}
                              sx={{ color: "#ec1a20" }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </Paper>

        {/* Modal d'upload de document */}
        <Dialog 
          open={showUploadFormulaire > 0} 
          onClose={handleCloseModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ 
            backgroundColor: "#00a652", 
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            Ajouter un document
            <IconButton
              size="small"
              onClick={handleCloseModal}
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <form onSubmit={uploadFile}>
            <DialogContent sx={{ mt: 2 }}>
              <TextField
                fullWidth
                size="small"
                label="Titre du document"
                value={titleFormulaire}
                onChange={(e) => setTitleFormulaire(e.target.value)}
                required
                sx={{
                  mb: 3,
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#00a652",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00a652",
                    },
                  },
                }}
              />
              
              <Button
                variant="outlined"
                component="label"
                fullWidth
                startIcon={<FileUploadIcon />}
                sx={{
                  color: "#00a652",
                  borderColor: "#00a652",
                  "&:hover": {
                    backgroundColor: "rgba(0,166,82,0.04)",
                    borderColor: "#00a652",
                  },
                  textTransform: "none",
                  padding: "10px",
                }}
              >
                {selectedFile ? selectedFile.name : "Choisir un fichier"}
                <input
                  type="file"
                  hidden
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                  required
                />
              </Button>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 2 }}>
              <Button 
                onClick={handleCloseModal}
                sx={{ 
                  color: "#666",
                  textTransform: "none"
                }}
              >
                Annuler
              </Button>
              <Button
                type="submit"
                variant="contained"
                startIcon={<FileUploadIcon />}
                sx={{
                  backgroundColor: "#00a652",
                  "&:hover": { backgroundColor: "#008c46" },
                  textTransform: "none",
                }}
              >
                Télécharger
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </Box>
    </Admin>
  );
};

export default AddFormulaireDeclaration;